import { render, staticRenderFns } from "./location-list-2.vue?vue&type=template&id=4eb3a761&"
import script from "./location-list-2.vue?vue&type=script&lang=js&"
export * from "./location-list-2.vue?vue&type=script&lang=js&"
import style0 from "./location-list-2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "location-list-2.vue"
export default component.exports